(()=>{
  const noGiftPackagingEl = document.querySelector(".gift-packaging-options-list .gift-packaging-no-bag-option");
  const giftPackagingEl = document.querySelector(".gift-packaging-options-list .gift-packaging-bag-option");
  const optionsList = document.querySelector(".gift-packaging-options-list")
  const noGiftInput = noGiftPackagingEl.querySelector("input");
  const giftPackagingInputId = document.querySelector("[name='items[2][id]']");
  const giftPackagingQuantity = document.querySelector("[name='items[2][quantity]']");
  const additionalBlock = document.querySelector(".gift-packaging .gift-packaging__info");
  const packagingValueLabel = document.querySelector(".gift-packaging [packaging-value]")
  const mainContent = document.querySelector(".gift-packaging__main")
  noGiftInput.click()
  giftPackagingEl.addEventListener("click", (e)=>{
    const optionEl = e.currentTarget;
    const inputOptionEl = optionEl.querySelector("input");
    optionEl.classList.add("active");
    
  })
  contentOpen();
  
  optionsList.addEventListener("click", onToggleActive);

  function onToggleActive(e){
    const closestOption = e.target.closest(".gift-packaging-option");
    if(!closestOption) return;
    const valueLableText = closestOption.getAttribute("data-value");

    const allOptions = e.currentTarget.querySelectorAll(".gift-packaging-option")
    allOptions.forEach(option=>{
      if(option != closestOption){
        option.classList.remove("active");
      }
    })
    closestOption.classList.add("active");
    if(closestOption == noGiftPackagingEl){
      giftPackagingInputId.disabled = true;
      giftPackagingQuantity.disabled = true
    }else{
      giftPackagingInputId.disabled = false;
      giftPackagingQuantity.disabled = false
    }
    packagingValueLabel.innerHTML = valueLableText
    window.setPriceAccordingPickedOptions();
  }

  function contentOpen(){
    const isHide = mainContent.classList.toggle("hidden");

    if(isHide){
      noGiftInput.click()
    }

  }
})()